/*
  form_opening
*/
/**
 * Desktop Form Opening with Smooth Scrolling
 */

/************************************************
	LISTENER
*************************************************/
$(document.body).on("click", ".claim-form-go", function(e) {
  //-- init
  var _this = $(this);
  e.preventDefault();

  //-- get the page's form
  var target = $("[class^=desk_main_form][data-type=module]").eq(0);
  var _this_href = _this.attr("href");

  //-- feed link with fake anchor & feed form with fake id, then click again to smooth scroll to the form
  if (_this_href === "#") {
    _this.attr("href", "#claim-form-go");
    target.attr("id", "claim-form-go");

    _this.trigger("click");
  }
  else {

    //-- show the form
    target.show().css("height", "auto");

    //-- scroll to the form
    $('html, body').stop().animate({
        scrollTop: target.offset().top
      }, 1000, function() {
    });
  }
});
